export default __webpack_public_path__ + "static/realWorldImg3-a45c921110eb11bc9ad9479779f3b141.webp";